export default __webpack_public_path__ + "static/media/communityIcon.683c8e6b.png";